import React from 'react';
import "./ProfileImage.scss";

const ProfileImage = (props) => {
	const { src, altTag, focused, noHover, user, initials, style, onClick } = props;

	const getInitials = () => {
		const arr = user && user.name && user.name.split(" ") || []
		let initials = arr && arr.map(word => word.charAt(0))
		return initials ? initials.join("") : ""
	}

	return (
		<div style={style} onClick={onClick} className={`profile-image-container${focused ? " profile-image-focused" : ""}${!user || !user.photo  ? " profile-initials" : ""}${noHover ? " profile-image-no-hover" : ""}`}>
			{user && user.photo ? <img src={src} alt={altTag ? altTag : "profile-image"} /> : initials ? initials : <div className="profile-image-text">{getInitials()}</div>}
		</div>
	)
}

export default ProfileImage;